module.exports = __webpack_public_path__ + "img/topicSurveys.108eba11.svg";